import _toConsumableArray from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/diogosoares/Documents/projetos/leveling-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import printValue from './util/printValue';
import toArray from './util/toArray';
var strReg = /\$\{\s*(\w+)\s*\}/g;

var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);

  var _super = _createSuper(ValidationError);

  function ValidationError(errorOrErrors, value, field, type) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _super.call(this);
    _this.name = 'ValidationError';
    _this.value = value;
    _this.path = field;
    _this.type = type;
    _this.errors = [];
    _this.inner = [];
    toArray(errorOrErrors).forEach(function (err) {
      if (ValidationError.isError(err)) {
        var _this$errors;

        (_this$errors = _this.errors).push.apply(_this$errors, _toConsumableArray(err.errors));

        _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        _this.errors.push(err);
      }
    });
    _this.message = _this.errors.length > 1 ? "".concat(_this.errors.length, " errors occurred") : _this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), ValidationError);
    return _this;
  }

  _createClass(ValidationError, null, [{
    key: "formatError",
    value: function formatError(message, params) {
      var path = params.label || params.path || 'this';
      if (path !== params.path) params = _extends({}, params, {
        path: path
      });
      if (typeof message === 'string') return message.replace(strReg, function (_, key) {
        return printValue(params[key]);
      });
      if (typeof message === 'function') return message(params);
      return message;
    }
  }, {
    key: "isError",
    value: function isError(err) {
      return err && err.name === 'ValidationError';
    }
  }]);

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { ValidationError as default };